import Separator from "@/common/components/separator";
import ChangePassword from "../containers/change-password";
import EditProfile from "../containers/edit-profile";

function ProfileSettingsPage() {
	return (
		<div className="flex w-full flex-col gap-12 pb-16">
			<p className="web-heading-h3-medium">Profile Settings</p>

			<EditProfile />

			<Separator />
			<ChangePassword />
		</div>
	);
}

export default ProfileSettingsPage;
